import { adminApi } from 'nove8/api'
import { ProcessingKey } from 'nove8/constants/root-constants'
import { useZustandStore } from 'zustandGlobalStore'

export const getDogsProfile = async (): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.GET_DOGS_PROFILE)

  const searchParams = new URLSearchParams(window.location.search)
  const tokenFromUrl = searchParams.get('token')

  if (tokenFromUrl) {
    const response = await adminApi.getDogsProfile(tokenFromUrl)

    if (response.success) {
      const dogsProfile = response.data.profiles

      useZustandStore.setState({ dogsProfile })
    }
  }
  useZustandStore.getState().stopProcessing(ProcessingKey.GET_DOGS_PROFILE)
}
